import { Categories, Tags } from '@eview/core/domain/tags/tag';

export interface TagsState {
  tags: Tags;
}

export interface CategoriesState {
  categories: Categories;
}

export const initialTagsState: TagsState = {
  tags: null
};

export const initialCategoriesState: CategoriesState = {
  categories: []
};
